<template>
    <div class="text-input-wrapper">
        <div class="input-container relative">
            <input 
                type="text" 
                :id="id" 
                v-model="internalValue" 
                :disabled="!enabled" 
                :required="field.required"
                class="text-input text-base text-[var(--charcoal-dark)] border border-[var(--bone)] focus:border-[var(--primary)] rounded-full h-9 px-3 py-1 bg-white w-full outline-0" 
                :class="{ 'input-error': display_errors && error, 'input-disabled': !enabled }"
                @input="$emit('update:value', internalValue); $emit('validate')" 
                :aria-describedby="errorId"
                :placeholder="field.placeholder || 'Enter text'" 
            />
            <div class="input-icon w-5 h-5 absolute right-4 top-1/2 -translate-y-1/2">
                <svg class="max-w-full" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
            </div>
        </div>
        <div v-if="display_errors && error" class="error-message flex items-center text-sm text-[var(--error)]" :id="errorId">
            <svg class="max-w-full mr-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: { type: Object, required: true },
        value: { type: String, default: '' },
        enabled: { type: Boolean, default: true },
        display_errors: { type: Boolean, default: false },
        error: { type: String, default: '' },
        idSuffix: { type: String, default: '' }
    },
    computed: {
        id() { return `field-${this.field.id}${this.idSuffix}`; },
        errorId() { return `error-field-${this.field.id}${this.idSuffix}`; },
        internalValue: {
            get() { return this.value; },
            set(newValue) { this.$emit('update:value', newValue); }
        }
    }
};
</script>